<template>

      <div class="accept-checkbox">
        <div 
        @click="changeAccept"
        class="accept-checkbox-rectangle">
          <img 
          v-if="isAccept"
          src="@/assets/images/acceptCheckMark.svg" alt="check mark">
        </div>

        <div
        @click="changeAccept"
        class="accept-checkbox-text">
          Принимаю
        </div>

      </div>

</template>

<script>
export default {
    name: 'AcceptCheckbox',
    props: {
        isAccept: Boolean
    },
    methods: {
        changeAccept(){
            this.$emit('changeAccept')
        }
    }
}
</script>

<style>

</style>